let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c9cT7")).then(() => parcelRequire('8j7Sz'));